import { Component, Input } from '@angular/core';

import { TableColumnModelExtended } from '../../../../../models/table-column.model';

@Component({
  selector: 'rnpl-column-with-date-indicator',
  templateUrl: './column-with-date-indicator.component.html',
  styleUrls: ['./column-with-date-indicator.component.scss']
})
export class ColumnWithDateIndicatorComponent {

  @Input()
  value: string;

  @Input()
  column: TableColumnModelExtended;

  @Input()
  showEmptyDash = true;

  @Input()
  indicatorColor: 'green' | 'yellow' | 'gray' | null = null;
}
